import { StatType } from "../types/ui";

export const tagStatusColours = {
    default: 'blue',
    danger: 'red',
    waiting: 'yellow',
    neutral: 'gray',
    teal: 'teal',
    success: 'green'
};

export const dealsBgColours = {
    email: '255, 192, 203',
    follow_up: '133, 133, 133',
    analysis: '69, 159, 69',
    revenue: '53, 53, 159',
    recording: '231, 231, 33',
    review: '',
}

export function computeTagStatusColor(value: string) {
    switch (value) {
		case 'pending':
		case 'Pending':
			return tagStatusColours['waiting'];
		case 'incomplete':
		case 'partiallyFilled':
		case 'crypto':
		case 'PartiallyAuthorized':
		case 'unsuitable':
			return '#F26F66';
		case 'complete':
		case 'stock':
		case 'payout':
		case 'Refunded':
		case 'PartiallyRefunded':
		case 'payOut':
		case 'Lost':
		case 'skipped':
		case 'suitable':
			return '#4ABCE2';
		case 'open':
			return '#2B77D0';
		case 'potential_match':
		case 'Risk':
		case 'risky':
			return '#E66E18';
		case 'Expired':
		case 'cancelled':
		case 'undelivered':
		case 'reversed':
		case 'partiallyReversed':
		case 'Reversed':
		case 'PartiallyReversed':
		case 'pendingCancel':
			return '#9B9B9B';
		case 'fiat':
		case 'USD':
			return '#26CEA2';
		case 'rejected':
		case 'Rejected':
		case 'rejectedFailed':
		case 'manuallyRejected':
		case 'failedToExecute':
		case 'failed':
		case 'closeOnly':
		case 'delisted':
		case 'Blocked':
			return '#D0021B';
		case 'verified':
		case 'executed':
		case 'success':
		case 'active':
		case 'collection':
		case 'Settled':
		case 'Activated':
		case 'approved':
		case 'systemApproved':
		case 'EUR':
			return '#67B81E';
		case 'inactive':
		case 'marginEnabledInactive':
		case 'NotActivated':
			return '#B5B7BA';
		case 'suspended':
		case 'Stolen':
			return '#BE3665';
		case 'primary':
		case 'default':
		case 'marginEnabled':
		case 'collateral':
		case 'fractionalTrading':
		case 'recurring':
		case 'postTradeSettlementEnabled':
		case 'authorized':
		case 'Authorized':
		case 'PreAuthorized':
			return '#416A9D';
		case 'clear':
		case 'no_match':
		case 'delivered':
			return '#6EBA1A';
		case 'Fraud':
			return '#e5293c';
		case 'utility_bill':
		case 'bank_statement':
		case 'credit_statement':
		case 'permanent_residency_card':
		case 'property_tax_receipt':
		case 'driving_license':
		case 'insurance_card':
		default:
			return '#6EBA1A';
		}
}

export const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export function computeStatBgColour(val: StatType): string {
	if (!val) return 'white';

	return `rgba(${dealsBgColours[val]}, 0.3)`
}